// the list of document types that have a 'custom controller', i.e. those that will not use the generic form builder
export const CUSTOM_CONTROLLER_DOC_TYPES = [
  // 'TYPE_VOUCHER_PAYMENT'
]

export const YESNO = [
  { value: true, label_en: 'Yes', label_fr: 'Oui' },
  { value: false, label_en: 'No', label_fr: 'Non' },
]

export const ACCESS_MODES = [
  { value: 1, label_en: 'Reader', label_fr: 'Lecteur' },
  { value: 2, label_en: 'Uploader', label_fr: 'Auteur' },
  { value: 3, label_en: 'Editor', label_fr: 'Editeur' },
]

export enum ArchiveDocumentState {
  NEW = 'new',
  DONE = 'done',
}
export const ARCHIVE_DOCUMENT_STATES = [
  { value: ArchiveDocumentState.NEW, severity: 'info', label_en: 'Draft', label_fr: 'Brouillon' },
  { value: ArchiveDocumentState.DONE, severity: 'success', label_en: 'Published', label_fr: 'Publié' },
]

export enum ArchiveDocumentTransition {
  VALIDATE = 'validate',
  REJECT = 'reject',
}
export const ARCHIVE_DOCUMENT_TRANSITIONS = [
  { value: ArchiveDocumentTransition.VALIDATE, label_en: 'Validate', label_fr: 'Valider' },
  { value: ArchiveDocumentTransition.REJECT, label_en: 'Reject', label_fr: 'Rejeter' },
]

export const ASSET_CATEGORIES = [
  { value: 'LAP', label_en: 'IT: Laptop', label_fr: 'IT: Ordinateurs portables' },
  { value: 'DES', label_en: 'IT: Desktop', label_fr: 'IT: Ordinateurs de bureau' },
  { value: 'PRI', label_en: 'IT: Printers, copy machines, scanners', label_fr: 'IT: Imprimantes, photocopieuses, scanners' },
  { value: 'TAB', label_en: 'IT: Tablet or equivalent', label_fr: 'IT: Tablettes ou équivalent' },
  { value: 'HAR', label_en: 'IT: Other hardware and peripherals', label_fr: 'IT: Autres matériels et périphériques' },
  { value: 'SOF', label_en: 'IT: Software', label_fr: 'IT: Logiciel' },
  { value: 'VHF', label_en: 'Comms: VHF Radios, bases, chargers, batteries', label_fr: 'Comms: Radios VHF, bases, chargeurs, batteries' },
  { value: 'HF', label_en: 'Comms: HF Radios, bases, chargers, batteries', label_fr: 'Comms: Radios HF, bases, chargeurs, batteries' },
  { value: 'INT', label_en: 'Comms: Internet equipment', label_fr: 'Comms: Équipement internet' },
  { value: 'TEL', label_en: 'Comms: Smartphones & cell phones', label_fr: 'Comms: Smartphones et téléphones portables' },
  { value: 'SAT', label_en: 'Comms: Satellite phones', label_fr: 'Comms: Téléphones satellitaires' },
  { value: 'SIM', label_en: 'Comms: SIM cards', label_fr: 'Comms: Cartes SIM' },
  { value: 'GEN', label_en: 'Energy: Generators', label_fr: 'Enérgie: Générateurs' },
  { value: 'UPS', label_en: 'Energy: UPS, stabilizers', label_fr: 'Enérgie: Onduleurs, stabilisateurs' },
  { value: 'CON', label_en: 'Energy: Converters', label_fr: 'Enérgie: Convertisseurs' },
  { value: 'SOL', label_en: 'Energy: Solar Panels', label_fr: 'Enérgie: Panneaux solaires' },
  { value: 'C', label_en: 'Transport: Cars (Acted)', label_fr: 'Transport: Voitures (Acted)' },
  { value: 'R', label_en: 'Transport: Cars (rented)', label_fr: 'Transport: Voitures (loués)' },
  { value: 'T', label_en: 'Transport: Trucks', label_fr: 'Transport: Camions' },
  { value: 'H', label_en: 'Transport: Heavy assets', label_fr: 'Transport: Actifs lourds' },
  { value: 'M', label_en: 'Transport: Motorbikes', label_fr: 'Transport: Motos' },
  { value: 'BOA', label_en: 'Transport: Boats', label_fr: 'Transport: Bateaux' },
]
